/**
 * Form.io UX helpers for the patient-facing forms.
 *
 * When a patient clicks Submit at the bottom of a long form and a required field is
 * incomplete, Form.io renders its error summary + red fields at the TOP of the form —
 * out of view — so it looks like nothing happened. This brings the first error into view
 * (and focuses the offending field) so the patient can see exactly what to fix.
 *
 * Wire it to the `<Form onError={...}>` prop (which maps to Form.io's `error` event,
 * emitted on a failed-validation submit).
 */
export function scrollToFirstFormError(scopeSelector = '.ci-formio-form'): void {
  // Let Form.io finish painting the error state before we look for it.
  window.setTimeout(() => {
    const root = document.querySelector(scopeSelector);
    if (!root) return;
    const el = root.querySelector(
      '.alert-danger, .formio-error, .has-error, .is-invalid, .formio-errors .error',
    );
    if (!(el instanceof HTMLElement)) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // If we landed on a field wrapper, focus its control so the patient is on the field.
    const input = el.matches('input, select, textarea')
      ? el
      : el.querySelector<HTMLElement>('input, select, textarea');
    input?.focus?.({ preventScroll: true });
  }, 80);
}
